<template>
<div>

   <v-btn
      color="primary"
      dark
      fab
      small
      @click="showParamsSelector=true"
      :class="['no-print smallerFab mt-1']"
      aria-label="Settings" title="Settings"
    >
      <v-icon small>mdi-settings-outline</v-icon>
    </v-btn>

    <ParamsSelector v-model="showParamsSelector" />

</div>
</template>

<script>
  import ParamsSelector from './ParamsSelector.vue'
  //import { mdiPlus } from '@mdi/js'
  //import { mdiNewBox } from '@mdi/js'
  //import { mdiSettings } from '@mdi/js'

  export default {
    name: 'paramsToggle',
    data () {
      return {
        //mdiPlus: mdiPlus,
        //mdiNewBox: mdiNewBox,
        //mdiSettings: mdiSettings,

        showParamsSelector: false
      }
    },
    computed: {
      iFramed() {
        return this.$store.state.iFramed
      }
    },
    components: {
      ParamsSelector
    }
  }
</script>

<style lang="scss" scoped>

</style>